import React, { Suspense, useEffect, useState } from 'react';
import useUserSession from '@medflex/hooks/useUserSession';
import ErrorBoundaryEmpty from '@medflex/components/stories/ErrorBoundaryEmpty';
import { FEATURE_KEYS } from '@medflex/utils/subscriptionEnums';
import useSessionChats from '../hooks/useSessionChats';
import useChatContacts from '../hooks/useChatContacts';
import useFeatures from '../hooks/useFeatures';
import useInvitationRequests from '../hooks/useInvitationRequests';
import useSubscription from '../hooks/useSubscription';
import getUnreadChatsCount from '../../utils/getUnreadChatsCount';
import setBadgeCount from '../../utils/electron/setBadgeCount';

// eslint-disable-next-line import/no-unresolved
const RemoteInboxUnreadRequestsCount = React.lazy(() => import('RemoteInbox/UnreadRequestsCount'));

const DesktopBadgeCount = () => {
  const [pamBadgeCount, setPamBadgeCount] = useState(0);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [unreadInvitationRequestCount, setUnreadInvitationRequestCount] = useState(0);

  const { session: userSession } = useUserSession();
  const { chats } = useSessionChats();
  const { contacts } = useChatContacts(true);
  const { invitationRequests } = useInvitationRequests(true);
  const [pamFeature] = useFeatures([FEATURE_KEYS.PAM]);
  const { plan: subscriptionPlan, email: subscriptionEmail } = useSubscription();

  useEffect(() => {
    if (!invitationRequests || !invitationRequests.length) {
      setUnreadInvitationRequestCount(0);
      return;
    }

    const newUnreadInvitationRequestCount = invitationRequests.filter(({ seen }) => !seen).length;
    setUnreadInvitationRequestCount(newUnreadInvitationRequestCount);
  }, [invitationRequests]);

  useEffect(() => {
    if (!contacts || !chats) return;
    const newUnreadMessages = getUnreadChatsCount(contacts, chats);
    setUnreadMessages(newUnreadMessages);
  }, [contacts, chats]);

  useEffect(() => {
    const newBadgeCount = unreadInvitationRequestCount + unreadMessages + pamBadgeCount;
    setBadgeCount(newBadgeCount);
  }, [unreadInvitationRequestCount, unreadMessages, pamBadgeCount]);

  return (
    <Suspense fallback={null}>
      <ErrorBoundaryEmpty>
        <RemoteInboxUnreadRequestsCount
          jwt={userSession?.access_token}
          disableStyles
          onChange={setPamBadgeCount}
          subscription={{
            plan: subscriptionPlan,
            email: subscriptionEmail,
            ...pamFeature,
          }}
        />
      </ErrorBoundaryEmpty>
    </Suspense>
  );
};

export default DesktopBadgeCount;
